import axios from "axios";
import {
  CREATED_TRAVELER_PROFILE,
  IPerson,
  TravelerProfileProperties,
  UPDATED_TRAVELER_PROFILE,
} from "redmond";

import { airBookingApi } from "@b2bportal/air-booking-api";
import { isCorpTenant, replaceObjectValues } from "@capone/common";
import { ToggleActions } from "halifax";
import { trackEvent } from "../../analytics/trackEvent";
import { config } from "../../../config";

export const updateUserPassenger = (
  body: IUpdateUserPassengerRequest
): Promise<IUpdateUserPassengerResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const {
        isNewTraveler,
        setIsMyProfile,
        hideProfileAction,
        entryPoint,
        person,
        ...payload
      } = body;

      const cleanPersonPayload = replaceObjectValues(person, "", null);

      const res = await airBookingApi(
        axios as any
      ).apiV0FlightPassengersUpdatePut({
        ...payload,
        person: cleanPersonPayload,
      });

      const responseBody: IUpdateUserPassengerResponse = res.data;
      resolve(responseBody);

      if (isCorpTenant(config.TENANT)) {
        const frequentFlyerProgramsAmount = Reflect.ownKeys(
          body.person.frequentFlyer
        ).length;
        const hotelLoyaltyProgramsAmount = Reflect.ownKeys(
          body.person.hotelLoyalty
        ).length;
        const carLoyaltyProgramsAmount = Reflect.ownKeys(
          body.person.groundLoyalty ?? {}
        ).length;

        trackEvent({
          eventName: isNewTraveler
            ? CREATED_TRAVELER_PROFILE
            : UPDATED_TRAVELER_PROFILE,
          properties: {
            frequent_flyer_program_added: frequentFlyerProgramsAmount > 0,
            num_frequent_flyer_programs: frequentFlyerProgramsAmount,
            hotel_loyalty_program_added: hotelLoyaltyProgramsAmount > 0,
            num_hotel_loyalty_programs: hotelLoyaltyProgramsAmount,
            car_loyalty_program_added: carLoyaltyProgramsAmount > 0,
            source: body.source,
            private: hideProfileAction === ToggleActions.ON,
            entry_point: entryPoint,
          } satisfies TravelerProfileProperties,
        });
      }
    } catch (e) {
      reject(e);
    }
  });

export interface IUpdateUserPassengerRequest {
  person: IPerson;
  isNewTraveler?: boolean;
  source?: string;
  setIsMyProfile?: boolean;
  hideProfileAction?: ToggleActions;
  entryPoint?: string;
}

export interface IUpdateUserPassengerResponse {}
